import { render, staticRenderFns } from "./ActivitySystem.vue?vue&type=template&id=28e2cf6e&scoped=true&"
import script from "./ActivitySystem.vue?vue&type=script&lang=js&"
export * from "./ActivitySystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e2cf6e",
  null
  
)

export default component.exports